import { cloneDeep, merge } from "lodash";
import { base, Locale } from "antd-mobile/es/locales/base";
import { CtxType } from "@al/next/al-ex";

export default function getAntdLocale(ctx: CtxType): Locale | undefined {
  const language = ctx.i18n.language;
  return merge(cloneDeep(base), {
    locale: language,
    common: {
      confirm: ctx.i18n.t?.("global:确定"),
      cancel: ctx.i18n.t?.("global:取消"),
    },
    PullToRefresh: {
      pulling: ctx.i18n.t?.("global:松开立即刷新"),
      canRelease: ctx.i18n.t?.("global:下拉可以刷新"),
      complete: ctx.i18n.t?.("global:完成刷新"),
    },
  });
}
